module.exports = __webpack_public_path__ + "img/logo-eestec.02612fa5.png";